
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/pageSettingsPanel/settings/tabs/PageSettingsPermissionsTab/PermissionsTabComponents/membersDashboardLink.scss.css.virtualfile';
        module.exports = {"controlRichText":"_controlRichText_lphul_7","symbol":"_symbol_lphul_12"};